import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../common.module.css';
import { authClient } from './defaults';
import defineImg from '../assets/defineImg.svg';
import assetsImg from '../assets/assetsImg.svg';
import exploreImg from '../assets/exploreImg.svg';
import importImg from '../assets/importImg.svg';
import arrow from '../assets/arrow_icon.svg';
import linePattern from '../assets/linePatternFlat.svg';

export default function DashboardPage() {
  const navigate = useNavigate();
  const cards = [
    {
      title: "Define",
      image: defineImg,
      to: "/config",
      bg: styles.bgDefine,
    },
    {
      title: "Assets",
      image: assetsImg,
      to: "/user/assets",
      bg: styles.bgAssets,
    },
    // {
    //   title: "Explore",
    //   image: exploreImg,
    //   to: "/explore",
    //   bg: styles.bgExplore,
    // },
    // {
    //   title: "Import",
    //   image: importImg,
    //   to: "/import",
    //   bg: styles.bgImport,
    // },
  ];
  const [userProfile, setUserProfile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const validateSession = async () => {
      try {
        const response = await authClient.get("/validate-session");

        if (response.data.isSessionValid) {
          setUserProfile({ firstName: response.data.user });
        } else {
          console.warn("Session is invalid. Redirecting to login.");
          setUserProfile(null);
        }
      } catch (err) {
        console.error("Error validating session:", err);
        setUserProfile(null);
      }
    };

    validateSession();
  }, []);

  return (
    <div className={styles.dashboardWrap}>
      <div className={styles.dashboardBody}>
        <div className={styles.welcomeBanner}>
          {userProfile ? (
            <>Welcome, {userProfile.firstName}!</>
          ) : (
            error && <span className={styles.errorText}>{error}</span>
          )}
        </div>
        <div className={styles.dashboardContent}>
          {cards.map((card) => (
            <div className={`${styles.dashboardCard} ${card.bg}`} key={card.title}>
              <Link to={card.to} className={styles.cardLink}>
                <div className={styles.imageWrapper}>
                  <img src={card.image} alt={card.title} className={styles.image} />
                </div>
                <div className={styles.cardFooter}>
                  <p className={styles.cardTitle}>{card.title}</p>
                  <div className={styles.arrowBlock}>
                    <img src={arrow} alt="arrow" />
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.bottomPattern}>
        <img src={linePattern} alt="illustration" />
      </div>
      <div className="navbar">
        <a href="/dashboard">Home</a>
        <div className="account-container">
          <a href="#" className="account-link">My Account</a>
          <div className="account-dropdown">
            <a href="/user/profile">Profile</a>
            <a href="/user/sessions">Sessions</a>
          </div>
        </div>
        <a href="/user/logout">Logout</a>
      </div>
    </div>

  );
}
